export default "__VITE_ASSET__CIRasf3G__"